var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.enough),expression:"!enough"}],attrs:{"id":_vm.id}},[_vm._t("default",function(){return [_c('span',[_vm._v(" Loading...")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }